import _asyncToGenerator from "/Volumes/Video_Back_Up/H2Zero-new/Landing_useThis/Superprops/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Volumes/Video_Back_Up/H2Zero-new/Landing_useThis/Superprops/node_modules/@babel/runtime/regenerator/index.js";
import { loadAngleUpdater } from "./Updaters/Angle";
import { loadCircleShape } from "./Shapes/Circle";
import { loadColorUpdater } from "./Updaters/Color";
import { loadExternalAttractInteraction } from "./Interactions/External/Attract";
import { loadExternalBounceInteraction } from "./Interactions/External/Bounce";
import { loadExternalBubbleInteraction } from "./Interactions/External/Bubble";
import { loadExternalConnectInteraction } from "./Interactions/External/Connect";
import { loadExternalGrabInteraction } from "./Interactions/External/Grab";
import { loadExternalRepulseInteraction } from "./Interactions/External/Repulse";
import { loadImageShape } from "./Shapes/Image";
import { loadLifeUpdater } from "./Updaters/Life";
import { loadLineShape } from "./Shapes/Line";
import { loadOpacityUpdater } from "./Updaters/Opacity";
import { loadOutModesUpdater } from "./Updaters/OutModes";
import { loadParticlesAttractInteraction } from "./Interactions/Particles/Attract";
import { loadParticlesCollisionsInteraction } from "./Interactions/Particles/Collisions";
import { loadParticlesLinksInteraction } from "./Interactions/Particles/Links";
import { loadPolygonShape } from "./Shapes/Polygon";
import { loadSizeUpdater } from "./Updaters/Size";
import { loadSquareShape } from "./Shapes/Square";
import { loadStarShape } from "./Shapes/Star";
import { loadStrokeColorUpdater } from "./Updaters/StrokeColor";
import { loadTextShape } from "./Shapes/Text";
export function loadSlim(_x) {
  return _loadSlim.apply(this, arguments);
}

function _loadSlim() {
  _loadSlim = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadExternalAttractInteraction(engine);

          case 2:
            _context.next = 4;
            return loadExternalBounceInteraction(engine);

          case 4:
            _context.next = 6;
            return loadExternalBubbleInteraction(engine);

          case 6:
            _context.next = 8;
            return loadExternalConnectInteraction(engine);

          case 8:
            _context.next = 10;
            return loadExternalGrabInteraction(engine);

          case 10:
            _context.next = 12;
            return loadExternalRepulseInteraction(engine);

          case 12:
            _context.next = 14;
            return loadParticlesAttractInteraction(engine);

          case 14:
            _context.next = 16;
            return loadParticlesCollisionsInteraction(engine);

          case 16:
            _context.next = 18;
            return loadParticlesLinksInteraction(engine);

          case 18:
            _context.next = 20;
            return loadCircleShape(engine);

          case 20:
            _context.next = 22;
            return loadImageShape(engine);

          case 22:
            _context.next = 24;
            return loadLineShape(engine);

          case 24:
            _context.next = 26;
            return loadPolygonShape(engine);

          case 26:
            _context.next = 28;
            return loadSquareShape(engine);

          case 28:
            _context.next = 30;
            return loadStarShape(engine);

          case 30:
            _context.next = 32;
            return loadTextShape(engine);

          case 32:
            _context.next = 34;
            return loadLifeUpdater(engine);

          case 34:
            _context.next = 36;
            return loadOpacityUpdater(engine);

          case 36:
            _context.next = 38;
            return loadSizeUpdater(engine);

          case 38:
            _context.next = 40;
            return loadAngleUpdater(engine);

          case 40:
            _context.next = 42;
            return loadColorUpdater(engine);

          case 42:
            _context.next = 44;
            return loadStrokeColorUpdater(engine);

          case 44:
            _context.next = 46;
            return loadOutModesUpdater(engine);

          case 46:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadSlim.apply(this, arguments);
}